import request from '../../utils/request'

export function businessData (data) {
  return request.post('/business/workbench/businessData', data, {
    trim: true
  })
}
export function shopRankList10 (data) {
  return request.post('/business/workbench/shopRankList10', data, {
    trim: true
  })
}
export function goodsRankList10 (data) {
  return request.post('/business/workbench/goodsRankList10', data, {
    trim: true
  })
}
export function couponData (data) {
  return request.post('/business/workbench/couponData', data, {
    trim: true
  })
}
export function integralData (data) {
  return request.post('/business/workbench/integralData', data, {
    trim: true
  })
}
